import { useEffect, useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import "./UniForm.css";

const UNIMES_LOGO =
	"data:image/jpeg;base64,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";

const initialForm = {
	titreComplet: "",
	titreAbrege: "",
	promoteur: "",
	cpp: "Non",
	cnil: "Non",
	porteur: "",
	lieuSignature: "",
	ipNom: "",
	ipGrade: "",
	ipEtab: "",
	ipAdresse: "",
	ipTel: "",
	ipFax: "",
	ipEmail: "",
	autres: "",
	laboratoire: "",
	riph: "Non",
	description: "",
	duree: "",
	criteres: "",
	recrutement: "",
	risques: "",
	stats: "",
	nombre: "",
	analyses: "",
	acces: "",
	qualite: "",
	indemnisation: "",
	conservation: "",
	pads: "",
};

const requiredFields = [
	"titreComplet",
	"porteur",
	"ipNom",
	"ipGrade",
	"ipEtab",
	"ipEmail",
	"laboratoire",
	"description",
	"duree",
	"criteres",
	"recrutement",
	"risques",
	"acces",
	"conservation",
];

function formatDate() {
	return new Date().toLocaleDateString("fr-FR", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
}

function SignaturePad({ canvasRef, onChange, onClear, label }) {
	const drawingRef = useRef(false);

	function getPosition(event) {
		const canvas = canvasRef.current;
		const rect = canvas.getBoundingClientRect();
		const pointer = event.touches ? event.touches[0] : event;

		return {
			x: pointer.clientX - rect.left,
			y: pointer.clientY - rect.top,
		};
	}

	function startDrawing(event) {
		event.preventDefault();
		const canvas = canvasRef.current;
		const context = canvas.getContext("2d");
		const position = getPosition(event);

		drawingRef.current = true;
		context.beginPath();
		context.moveTo(position.x, position.y);
	}

	function draw(event) {
		if (!drawingRef.current) return;
		event.preventDefault();

		const canvas = canvasRef.current;
		const context = canvas.getContext("2d");
		const position = getPosition(event);

		context.lineTo(position.x, position.y);
		context.stroke();
	}

	function stopDrawing() {
		if (!drawingRef.current) return;
		drawingRef.current = false;
		onChange(canvasRef.current.toDataURL("image/png"));
	}

	useEffect(() => {
		const canvas = canvasRef.current;
		if (!canvas) return undefined;

		function resizeCanvas() {
			const rect = canvas.getBoundingClientRect();
			const ratio = Math.max(window.devicePixelRatio || 1, 1);

			canvas.width = Math.round(rect.width * ratio);
			canvas.height = Math.round(rect.height * ratio);

			const context = canvas.getContext("2d");
			context.setTransform(ratio, 0, 0, ratio, 0, 0);
			context.lineWidth = 2.2;
			context.lineCap = "round";
			context.lineJoin = "round";
			context.strokeStyle = "#000";
		}

		resizeCanvas();
		window.addEventListener("resize", resizeCanvas);
		window.addEventListener("mouseup", stopDrawing);

		return () => {
			window.removeEventListener("resize", resizeCanvas);
			window.removeEventListener("mouseup", stopDrawing);
		};
	}, []);

	return (
		<div className="signature-field">
			<div className="signature-toolbar">
				<span>{label}</span>
				<button
					className="btn-secondary"
					type="button"
					onClick={onClear}
				>
					Effacer
				</button>
			</div>

			<canvas
				ref={canvasRef}
				className="signature-pad"
				aria-label={label}
				onMouseDown={startDrawing}
				onMouseMove={draw}
				onMouseUp={stopDrawing}
				onMouseLeave={stopDrawing}
				onTouchStart={startDrawing}
				onTouchMove={draw}
				onTouchEnd={stopDrawing}
			/>
		</div>
	);
}

export default function CedForm3() {
	const pdfRef = useRef(null);
	const porteurCanvasRef = useRef(null);
	const ipCanvasRef = useRef(null);

	const [showIntro, setShowIntro] = useState(true);
	const [form, setForm] = useState(initialForm);
	const [porteurSignature, setPorteurSignature] = useState("");
	const [ipSignature, setIpSignature] = useState("");
	const [error, setError] = useState("");

	const today = formatDate();

	function handleChange(event) {
		const { name, value } = event.target;
		setForm((previous) => ({ ...previous, [name]: value }));
	}

	function clearCanvas(canvasRef, setter) {
		const canvas = canvasRef.current;
		if (!canvas) return;

		const context = canvas.getContext("2d");
		context.clearRect(0, 0, canvas.width, canvas.height);
		setter("");
	}

	async function downloadPDF() {
		const missingField = requiredFields.find(
			(field) => !String(form[field] || "").trim(),
		);

		if (missingField) {
			setError("Merci de remplir tous les champs obligatoires.");
			document.getElementById(missingField)?.focus();
			return;
		}

		setError("");

		const element = pdfRef.current;

		if (!element) {
			setError("Impossible de générer le PDF.");
			return;
		}

		const safeTitle = form.titreComplet
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.replace(/[^a-zA-Z0-9]+/g, "-")
			.replace(/^-|-$/g, "")
			.toLowerCase();

		element.classList.add("pdf-mode");

		try {
			await html2pdf()
				.set({
					margin: [10, 10, 10, 10],
					filename: `fiche-projet-recherche-ced-${
						safeTitle || "projet"
					}.pdf`,
					image: { type: "jpeg", quality: 0.98 },
					html2canvas: {
						scale: 2,
						useCORS: true,
						backgroundColor: "#ffffff",
						scrollX: 0,
						scrollY: 0,
						windowWidth: element.scrollWidth,
					},
					jsPDF: {
						unit: "mm",
						format: "a4",
						orientation: "portrait",
					},
					pagebreak: {
						mode: ["avoid-all", "css", "legacy"],
						avoid: [
							"p",
							".doc-section",
							".signature-block",
							".project-titles",
							".doc-title",
							".doc-subtitle",
							".doc-rule",
						],
					},
				})
				.from(element)
				.save();
		} catch (pdfError) {
			console.error("Erreur lors de la génération du PDF :", pdfError);
			setError("Une erreur est survenue pendant la génération du PDF.");
		} finally {
			element.classList.remove("pdf-mode");
		}
	}

	return (
		<div className="uniFormPage uniFormPage3 projectFormPage">
			{showIntro && (
				<section className="intro-screen" aria-labelledby="introTitle">
					<article className="intro-page">
						<img
							className="intro-logo"
							src={UNIMES_LOGO}
							alt="Logo Nîmes Université"
						/>
						<h1 id="introTitle">Projet de recherche</h1>
						<p className="intro-warning">
							Le CED n’étudiera aucun dossier incomplet.
						</p>
						<p>
							L’enjeu d’une évaluation éthique est d’évaluer le
							plus exactement possible si l’équilibre entre les
							supposés bénéfices de la recherche et les risques
							qu’elle fait courir aux participants est acceptable.
						</p>
						<p>
							Cet équilibre est communément appelé l’équilibre
							bénéfices/risques. Ce ne sont donc pas les risques
							seuls qui déterminent l’avis éthique d’une
							recherche. Les bénéfices (évalués par la validité
							scientifique et la pertinence de la recherche) et la
							gestion des risques sont centraux. Si les risques
							sont bien détaillés, cela nous permet de vous
							accompagner efficacement dans la diminution de leur
							probabilité d’occurrence et de leur ampleur.
						</p>{" "}
						<p>
							Cette mission d’accompagnement et de conseil étant
							centrale dans l’activité du comité d’éthique et de
							déontologie, il va donc de soi que le CED ne peut
							pas évaluer un dossier d’une recherche déjà débutée.
						</p>
						<p>
							Tout au long du dossier, ayez en tête l’équilibre
							bénéfices/risques et exposez les informations
							pertinentes pour l’évaluer. Il est donc nécessaire
							de bien détailler toutes les informations nous
							permettant d’évaluer le plus facilement possible cet
							équilibre.
						</p>
						<h2>
							Pour savoir si vous êtes concernés par la collecte
							des Données à Caractère Personnel (DCP), posez-vous
							les questions suivantes :
						</h2>
						<p>
							<em>
								*Est-ce qu’à un moment ou un autre, je collecte
								des informations qui permettent d’identifier
								directement une personne ?
							</em>
						</p>{" "}
						<p>
							Exemples : nom, prénom, e-mail, photo,
							enregistrement de la voix, enregistrement
							visioconférence, vidéo de surveillance, entretien
							filmé, recherche filmée, conférence filmée,
							trombinoscope, numéro de sécurité sociale, etc.
						</p>{" "}
						<p>
							<em>
								*Est-ce qu’à un moment ou un autre, je collecte
								des informations qui permettent d’identifier
								indirectement une personne ?
							</em>
						</p>{" "}
						<p>
							Exemples : numéro de téléphone, adresse postale, IP,
							empreinte digitale, etc.
						</p>{" "}
						<p>
							<em>
								*Est-ce qu’à un moment ou un autre, je collecte
								des informations qui permettent malgré moi
								d’identifier une personne par recoupement ?
							</em>
						</p>
						<p>
							Exemple : en collectant la date de naissance +
							école/université de votre participant, vous pourriez
							être en mesure de remonter à l’identité de votre
							participant.
						</p>
						<h2>
							Vous avez répondu OUI à au moins une de ces
							questions ?
						</h2>
						<p>
							La collecte de ces informations et ce que vous en
							faites (que vous les analysiez ou non) constitue un
							traitement de données à caractère personnel
							(également appelées données personnelles) qui est
							soumis à la fois : (1) à la législation européenne :
							Règlement général (UE) 2016/679 sur la protection
							des données (RGPD) (2) à la législation française :
							Loi du 6 janvier 1978 modifiée (loi « informatique
							et libertés »).
						</p>
						<h2>Posez-vous ensuite les questions suivantes :</h2>
						<p>
							*Je collecte en plus des informations sur une
							personne qui sont qualifiées de données sensibles ?
						</p>
						<p>Liste des données sensibles :</p>
						<p>
							- l’origine raciale ou ethnique,
							<br />
							- les opinions politiques,
							<br />
							- les convictions religieuses ou philosophiques,
							<br />
							- l’appartenance syndicale,
							<br />
							- les données génétiques,
							<br />
							- les données biométriques qui identifient une
							personne physique,
							<br />
							- les données de santé,
							<br />
							- la vie sexuelle ou l’orientation sexuelle.
							<br />
						</p>{" "}
						<p>
							<strong>
								Dans ce cas, la loi renforce les critères de
								conformité pour la protection des personnes et
								de leur vie privée, selon des procédures
								spécifiques renforcées, le cas échéant selon des
								normes définies par la loi.
							</strong>
						</p>
						<h2>Vos buts sont alors :</h2>
						<p>
							<em>
								1) de minimiser le recueil de données
								personnelles inutiles : Ne collectez que ce qui
								est nécessaire pour votre recherche.
							</em>{" "}
						</p>
						<p>
							Par exemple : Avez-vous vraiment besoin de connaitre
							la profession des participants pour atteindre vos
							objectifs de recherche ? Avez-vous besoin de
							connaitre la date de naissance au jour près (plutôt
							que l’année de naissance ou encore mieux, une
							fourchette d’âge) ? Avez-vous besoin de savoir
							exactement le critère de non-inclusion qui concerne
							le participant ? Il ne s’agit pas de ne pas du tout
							recueillir ce genre de données, mais il est
							nécessaire 1) de garder uniquement ce dont vous avez
							vraiment besoin (Exemple : CSP au lieu de la
							profession ; âge au lieu de la date de naissance ;
							lister l’ensemble des critères de non-inclusion et
							demander seulement au participant de dire s’il est
							concerné par au moins un de ces critères sans
							préciser lequel), 2) de prévenir les risques de
							cette collecte et 3) de donner des garanties de
							confidentialité aux participants.{" "}
						</p>
						<p>
							<em>
								2) de minimiser les risques lorsque ces données
								sont indispensables à votre recherche.{" "}
							</em>{" "}
						</p>
						<p>
							Par exemple : Chiffrer les données, les archiver
							dans des lieux sécurisés, ne pas les diffuser.{" "}
						</p>
						<p>
							<strong>
								{" "}
								Le référent CNIL / RGPD de l’établissement (dit
								DPO, data protection officer) peut vous aider
								dans cette démarche.{" "}
							</strong>
						</p>
						<p>
							<em>Source : CER Grenoble-Alpes.</em>
						</p>
						<div className="intro-actions">
							<button
								type="button"
								className="intro-start"
								onClick={() => setShowIntro(false)}
							>
								J’ai lu — commencer à compléter
							</button>
						</div>
					</article>
				</section>
			)}

			<div className="page">
				<div className="layout project-layout">
					<aside className="card panel project-panel">
						<h2>Compléter la fiche projet</h2>
						<p className="panel-intro">
							Les informations saisies sont reprises dans l’aperçu
							et le PDF.
						</p>

						<form
							className="form-grid"
							autoComplete="off"
							onSubmit={(event) => event.preventDefault()}
						>
							<p className="section-label">Étude</p>

							<div className="field">
								<label htmlFor="titreComplet">
									Titre complet *
								</label>
								<input
									id="titreComplet"
									name="titreComplet"
									value={form.titreComplet}
									onChange={handleChange}
									required
								/>
							</div>

							<div className="field">
								<label htmlFor="titreAbrege">
									Titre abrégé
								</label>
								<input
									id="titreAbrege"
									name="titreAbrege"
									value={form.titreAbrege}
									onChange={handleChange}
								/>
							</div>

							<p className="section-label">
								Informations générales
							</p>

							<div className="field">
								<label htmlFor="promoteur">
									Promoteur, si nécessaire
								</label>
								<input
									id="promoteur"
									name="promoteur"
									value={form.promoteur}
									onChange={handleChange}
								/>
							</div>

							<div className="field two">
								<div>
									<label htmlFor="cpp">
										Saisine d’un CPP
									</label>
									<select
										id="cpp"
										name="cpp"
										value={form.cpp}
										onChange={handleChange}
									>
										<option value="Non">Non</option>
										<option value="Oui">Oui</option>
									</select>
								</div>

								<div>
									<label htmlFor="cnil">
										Saisine du référent CNIL / RGPD
									</label>
									<select
										id="cnil"
										name="cnil"
										value={form.cnil}
										onChange={handleChange}
									>
										<option value="Non">Non</option>
										<option value="Oui">Oui</option>
									</select>
								</div>
							</div>

							<div className="field">
								<label htmlFor="porteur">
									Porteur du projet — nom et prénom *
								</label>
								<input
									id="porteur"
									name="porteur"
									value={form.porteur}
									onChange={handleChange}
									required
								/>
							</div>

							<div className="field">
								<label htmlFor="lieuSignature">
									Lieu de signature
								</label>
								<input
									id="lieuSignature"
									name="lieuSignature"
									value={form.lieuSignature}
									onChange={handleChange}
									placeholder="Nîmes"
								/>
							</div>

							<SignaturePad
								canvasRef={porteurCanvasRef}
								label="Signature du porteur du projet"
								onChange={setPorteurSignature}
								onClear={() =>
									clearCanvas(
										porteurCanvasRef,
										setPorteurSignature,
									)
								}
							/>

							<p className="section-label">
								Investigateur principal coordinateur
							</p>

							<div className="field two">
								<div>
									<label htmlFor="ipNom">Nom, prénom *</label>
									<input
										id="ipNom"
										name="ipNom"
										value={form.ipNom}
										onChange={handleChange}
										required
									/>
								</div>

								<div>
									<label htmlFor="ipGrade">
										Grade et qualité *
									</label>
									<input
										id="ipGrade"
										name="ipGrade"
										value={form.ipGrade}
										onChange={handleChange}
										required
									/>
								</div>
							</div>

							<div className="field">
								<label htmlFor="ipEtab">Établissement *</label>
								<input
									id="ipEtab"
									name="ipEtab"
									value={form.ipEtab}
									onChange={handleChange}
									required
								/>
							</div>

							<div className="field">
								<label htmlFor="ipAdresse">Adresse</label>
								<input
									id="ipAdresse"
									name="ipAdresse"
									value={form.ipAdresse}
									onChange={handleChange}
								/>
							</div>

							<div className="field two">
								<div>
									<label htmlFor="ipTel">Téléphone</label>
									<input
										id="ipTel"
										name="ipTel"
										value={form.ipTel}
										onChange={handleChange}
									/>
								</div>

								<div>
									<label htmlFor="ipFax">Fax</label>
									<input
										id="ipFax"
										name="ipFax"
										value={form.ipFax}
										onChange={handleChange}
									/>
								</div>
							</div>

							<div className="field">
								<label htmlFor="ipEmail">E-mail *</label>
								<input
									id="ipEmail"
									name="ipEmail"
									type="email"
									value={form.ipEmail}
									onChange={handleChange}
									required
								/>
							</div>

							<SignaturePad
								canvasRef={ipCanvasRef}
								label="Signature de l’investigateur principal"
								onChange={setIpSignature}
								onClear={() =>
									clearCanvas(ipCanvasRef, setIpSignature)
								}
							/>

							<div className="field">
								<label htmlFor="autres">
									Autres investigateurs et collaborateurs
									scientifiques
								</label>
								<textarea
									id="autres"
									name="autres"
									value={form.autres}
									onChange={handleChange}
								/>
							</div>

							<p className="form-subsection">
								1.1.4 — Implication de Nîmes Université
							</p>

							<div className="field">
								<label htmlFor="laboratoire">
									Laboratoire de Nîmes Université impliqué *
								</label>
								<input
									id="laboratoire"
									name="laboratoire"
									value={form.laboratoire}
									onChange={handleChange}
									required
								/>
							</div>

							<p className="section-label">
								Description générale
							</p>

							<div className="field">
								<label htmlFor="riph">
									Recherche impliquant la personne humaine ?
								</label>
								<select
									id="riph"
									name="riph"
									value={form.riph}
									onChange={handleChange}
								>
									<option value="Non">Non</option>
									<option value="Oui">Oui</option>
								</select>
							</div>

							<div className="field">
								<label htmlFor="description">
									Contexte théorique, méthodologie et
									déroulement * < br />< br />



Le contexte théorique permet de situer la recherche par rapport aux connaissances scientifiques actuelles sur le sujet et donc de justifier de la pertinence et de la portée de la recherche (l’équilibre bénéfices/risques). Votre projet est susceptible d’être lu par les membres d’une autre discipline de recherche ou non-scientifiques du CED. Veillez à expliciter les termes scientifiques spécialisés et à donner toutes les informations nécessaires pour que le CED puisse comprendre les objectifs et la mise en place de l’étude. Des annexes peuvent être ajoutées pour préciser les questionnaires ou mesures.

								</label>
								<textarea
									id="description"
									name="description"
									value={form.description}
									onChange={handleChange}
									defaultValue=""
									required
								/>
							</div>

							<div className="field">
								<label htmlFor="duree">
									Durée prévue de participation *
								</label>
								<textarea
									id="duree"
									name="duree"
									className="compact"
									value={form.duree}
									onChange={handleChange}
									required
								/>
							</div>

							<p className="section-label">
								Sélection et recrutement
							</p>

							<div className="field">
								<label htmlFor="criteres">
									Critères d’inclusion et d’exclusion *
								</label>
								<textarea
									id="criteres"
									name="criteres"
									value={form.criteres}
									onChange={handleChange}
									required
								/>
							</div>

							<div className="field">
								<label htmlFor="recrutement">
									Mode de recrutement *
								</label>
								<textarea
									id="recrutement"
									name="recrutement"
									value={form.recrutement}
									onChange={handleChange}
									required
								/>
							</div>

							<p className="section-label">
								Risques et effets indésirables
							</p>

							<div className="field">
								<label htmlFor="risques">
									Risques liés à la recherche *
								</label>
								<textarea
									id="risques"
									name="risques"
									value={form.risques}
									onChange={handleChange}
									required
								/>
							</div>

							<p className="section-label">Statistiques</p>

							{[
								["stats", "Méthodes statistiques prévues"],
								[
									"nombre",
									"Nombre prévu de personnes et justification",
								],
								[
									"analyses",
									"Choix des personnes incluses dans les analyses",
								],
							].map(([name, label]) => (
								<div className="field" key={name}>
									<label htmlFor={name}>{label}</label>
									<textarea
										id={name}
										name={name}
										value={form[name]}
										onChange={handleChange}
									/>
								</div>
							))}

							<p className="section-label">
								6 — Droit d’accès aux données et documents
								source
							</p>

							<div className="field">
								<label htmlFor="acces">
									Personnes pouvant accéder aux données
									recueillies *
								</label>
								<textarea
									id="acces"
									name="acces"
									value={form.acces}
									onChange={handleChange}
									required
								/>
							</div>

							<p className="section-label">
								7 — Contrôle et assurance de la qualité
							</p>

							<div className="field">
								<label htmlFor="qualite">
									Contrôle et assurance de la qualité
								</label>
								<textarea
									id="qualite"
									name="qualite"
									value={form.qualite}
									onChange={handleChange}
								/>
							</div>

							<p className="section-label">
								8 — Considérations éthiques
							</p>

							<div className="field">
								<label htmlFor="indemnisation">
									Indemnisation des participants, en €
								</label>
								<input
									id="indemnisation"
									name="indemnisation"
									type="number"
									min="0"
									step="0.01"
									value={form.indemnisation}
									onChange={handleChange}
								/>
							</div>

							<p className="section-label">
								9 — Traitement des données et conservation
							</p>

							<div className="field">
								<label htmlFor="conservation">
									Conservation des données : durée, lieu et
									garanties *
								</label>
								<textarea
									id="conservation"
									name="conservation"
									value={form.conservation}
									onChange={handleChange}
									required
								/>
							</div>

							<p className="section-label">
								10 — Numéro PADS si données médicales
							</p>

							<div className="field">
								<label htmlFor="pads">Numéro PADS</label>
								<input
									id="pads"
									name="pads"
									value={form.pads}
									onChange={handleChange}
								/>
							</div>
						</form>

						<p className="error" aria-live="polite">
							{error}
						</p>

						<div className="actions single-action">
							<button
								className="btn btn-primary download-btn"
								type="button"
								onClick={downloadPDF}
							>
								Télécharger en PDF
							</button>
						</div>
					</aside>

					<section className="card document-wrap project-document-wrap">
						<article
							className="document project-document"
							ref={pdfRef}
						>
							<img
								className="unimes-logo"
								src={UNIMES_LOGO}
								alt="Logo Nîmes Université"
							/>

							<h1 className="doc-title">
								Demande d’avis au Comité d’éthique
							</h1>
							<h2 className="doc-subtitle">
								et de déontologie de Nîmes Université
							</h2>

							<div className="doc-rule" />

							<div className="project-titles">
								<p className="project-title-value">
									{form.titreComplet ||
										"Titre complet du projet"}
								</p>
								<p className="project-short-value">
									{form.titreAbrege || "Titre abrégé"}
								</p>
							</div>

							<section className="doc-section">
								<h3>1 — Informations générales</h3>
								<p>
									<strong>Promoteur :</strong>
									<span className="fillable">
										{form.promoteur || ""}
									</span>
								</p>

								<p>
									<strong>Saisine d’un CPP :</strong>{" "}
									{form.cpp}
								</p>

								{form.cpp === "Oui" && (
									<p>
										Merci de faire parvenir l’avis du Comité
										de Protection des Personnes.
									</p>
								)}

								<p>
									<strong>
										Saisine du référent CNIL / RGPD :
									</strong>
									{form.cnil}
								</p>

								<div className="signature-block">
									<p>
										À
										<span className="fillable">
											{form.lieuSignature || ""}
										</span>
										, le {today}
									</p>
									<p>
										<strong>Porteur du projet :</strong>
										<span className="fillable">
											{form.porteur || ""}
										</span>
									</p>

									{porteurSignature && (
										<img
											className="signature-preview"
											src={porteurSignature}
											alt="Signature du porteur du projet"
										/>
									)}
								</div>
							</section>

							<section className="doc-section">
								<h3>1.1.3 — Investigateur</h3>

								<div className="preview-box">
									<p>
										<strong>Nom, prénom :</strong>
										<span className="fillable">
											{form.ipNom || ""}
										</span>
									</p>
									<p>
										<strong>Grade et qualité :</strong>
										{form.ipGrade || ""}
									</p>
									<p>
										<strong>Établissement :</strong>
										{form.ipEtab || ""}
									</p>
									<p>
										<strong>Adresse :</strong>{" "}
										{form.ipAdresse || ""}
									</p>
									<p>
										<strong>Téléphone :</strong>{" "}
										{form.ipTel || ""}
									</p>
									<p>
										<strong>Fax :</strong>{" "}
										{form.ipFax || ""}
									</p>
									<p>
										<strong>E-mail :</strong>
										{form.ipEmail || ""}
									</p>
								</div>

								{ipSignature && (
									<img
										className="signature-preview"
										src={ipSignature}
										alt="Signature de l’investigateur principal"
									/>
								)}

								<p>
									<strong>
										Autres investigateurs et collaborateurs
										scientifiques :
									</strong>
								</p>
								<p className="preview-box">
									{form.autres || ""}
								</p>
							</section>

							<section className="doc-section">
								<h3>1.1.4 — Implication de Nîmes Université</h3>
								<p>
									Laboratoire impliqué :
									<span className="fillable">
										{form.laboratoire || ""}
									</span>
								</p>
							</section>

							<section className="doc-section">
								<h3>
									2 — Description générale de la recherche
								</h3>
								<p>
									<strong>
										Recherche impliquant la personne humaine
										:
									</strong>
									{form.riph}
								</p>
								<p>
									<strong>
										Contexte théorique, méthodologie et
										déroulement :
									</strong>
								</p>
								<p className="preview-box">
									{form.description || ""}
								</p>
								<p>
									<strong>
										Durée prévue de participation :
									</strong>
								</p>
								<p className="preview-box">
									{form.duree || ""}
								</p>
							</section>

							<section className="doc-section">
								<h3>3 — Sélection et exclusion</h3>
								<p>
									<strong>
										Critères d’inclusion et d’exclusion :
									</strong>
								</p>
								<p className="preview-box">
									{form.criteres || ""}
								</p>
								<p>
									<strong>Mode de recrutement :</strong>
								</p>
								<p className="preview-box">
									{form.recrutement || ""}
								</p>
							</section>

							<section className="doc-section">
								<h3>4 — Effets indésirables et risques</h3>
								<p className="preview-box">
									{form.risques || ""}
								</p>
							</section>

							<section className="doc-section">
								<h3>5 — Statistiques</h3>
								<p>
									<strong>
										Méthodes statistiques prévues :
									</strong>
								</p>
								<p className="preview-box">
									{form.stats || ""}
								</p>
								<p>
									<strong>
										Nombre prévu de personnes et
										justification :
									</strong>
								</p>
								<p className="preview-box">
									{form.nombre || ""}
								</p>
								<p>
									<strong>
										Choix des personnes incluses dans les
										analyses :
									</strong>
								</p>
								<p className="preview-box">
									{form.analyses || ""}
								</p>
							</section>

							<section className="doc-section">
								<h3>6 — Droit d’accès aux données</h3>
								<p className="preview-box">
									{form.acces || ""}
								</p>
							</section>

							<section className="doc-section">
								<h3>7 — Contrôle et assurance qualité</h3>
								<p className="preview-box">
									{form.qualite || ""}
								</p>
							</section>

							<section className="doc-section">
								<h3>8 — Considérations éthiques</h3>
								<p>
									• Présentation de la feuille de
									consentement.
								</p>
								<p>
									• Présentation de la notice d’information.
								</p>
								<p>• Anonymat des données.</p>

								<p>
									<strong>
										Méthode d’anonymisation à présenter
									</strong>
								</p>

								<p>
									Il ne faut pas confondre confidentialité et
									anonymat. L’anonymisation vise à rendre
									impossible l’identification des personnes de
									manière irréversible. La pseudonymisation
									permet de ne plus attribuer les données à
									une personne sans information
									supplémentaire.
								</p>

								<p>
									Les participants recevront une indemnisation
									de
									<span className="fillable">
										{form.indemnisation || ""}
									</span>
									€.
								</p>
							</section>

							<section className="doc-section">
								<h3>
									9 — Traitement des données et conservation
									des documents
								</h3>
								<p>
									• Présence du ou des questionnaires si
									nécessaire.
								</p>
								<p className="preview-box">
									{form.conservation || ""}
								</p>
							</section>

							{form.pads.trim() && (
								<section className="doc-section">
									<h3>
										10 — Numéro PADS si données médicales
									</h3>
									<p className="preview-box">{form.pads}</p>
								</section>
							)}
						</article>
					</section>
				</div>
			</div>
		</div>
	);
}
